<template>
  <TransitionRoot as="template" :show="isOpen">
    <DialogContainer as="div" class="relative z-50" @close="noDismiss ? undefined : close()">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0">
        <div class="fixed inset-0 bg-neutral-900/85 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform rounded-lg bg-white dark:bg-neutral-800 text-left shadow-xl transition-all sm:my-8 w-full"
              :class="
                size === 'xl'
                  ? 'sm:max-w-[90vw]'
                  : size === 'lg'
                    ? 'sm:max-w-4xl'
                    : size === 'md'
                      ? 'sm:max-w-2xl'
                      : 'sm:max-w-lg'
              ">
              <div class="absolute right-0 top-0 z-10 hidden pr-4 pt-4 sm:block" v-if="!noDismiss">
                <button
                  type="button"
                  class="w-6 h-6 flex items-center justify-center rounded-md bg-white dark:bg-neutral-800 text-neutral-400 dark:text-neutral-300 hover:text-neutral-500 dark:hover:text-neutral-400 focus:outline-hidden focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 dark:ring-offset-neutral-800"
                  @click="close">
                  <span class="sr-only">Close</span>
                  <i class="fa-sharp fa-regular fa-times" aria-hidden="true" />
                </button>
              </div>
              <div class="bg-white dark:bg-neutral-800 p-4 sm:p-6 rounded-lg">
                <DialogTitle
                  v-if="heading"
                  as="h3"
                  class="text-base font-semibold leading-6 text-neutral-900 dark:text-white">
                  {{ heading }}
                </DialogTitle>
                <div class="mt-2 text-sm text-neutral-500 dark:text-neutral-400 leading-normal @container">
                  <slot />
                </div>
              </div>
              <div
                v-if="$slots.footer"
                class="bg-neutral-50 dark:bg-neutral-700 px-4 py-3 flex sm:flex-row-reverse sm:px-6 rounded-b-lg gap-3">
                <slot name="footer" />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </DialogContainer>
  </TransitionRoot>
</template>

<script>
import { Dialog as DialogContainer, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

export default {
  components: {
    DialogContainer,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot
  },
  emits: ['opened', 'closed'],
  props: {
    heading: {
      type: String,
      default: null
    },
    noDismiss: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'sm'
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      this.isOpen = true
      this.$emit('opened')
    },
    close() {
      this.isOpen = false
      this.$emit('closed')
    }
  }
}
</script>
